"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = require("@eitje/utils");

var _utils2 = _interopRequireDefault(_utils);

var _ui = require("./ui");

var UI = _interopRequireWildcard(_ui);

var _bridge = require("./bridge");

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({}, _utils2.default, UI);
exports.setup = _bridge2.default;